import { ConfigDataType, WhatsappTemplateSettings } from "../types";

export const getWhatsappTemplatesFromConfig = (config?: ConfigDataType): WhatsappTemplateSettings[] => {
  return Object.values(config?.whatsappTemplates || {});
};

export const filterWhatsappTemplatesByTags = (
  templates: WhatsappTemplateSettings[],
  tags?: string[]
): WhatsappTemplateSettings[] => {
  if (!tags?.length) return templates;
  const tagSet = new Set(tags);
  return templates.filter((template) => template.tags?.some((tag) => tagSet.has(tag)));
};

export const findWhatsappTemplateById = (
  templates: WhatsappTemplateSettings[],
  id?: string
): WhatsappTemplateSettings | undefined => {
  if (!id) return undefined;
  return templates.find((template) => template.id === id);
};

export const findWhatsappTemplateByTemplateId = (
  templates: WhatsappTemplateSettings[],
  templateId?: string
): WhatsappTemplateSettings | undefined => {
  if (!templateId) return undefined;
  return templates.find((template) => template.templateId === templateId);
};

export const getWhatsappTemplateLabel = (template: WhatsappTemplateSettings): string => {
  return template.title || template.id || template.templateId || "?";
};
